// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"kXR15yCOrcScwSNCid2Q4"};